import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../../shared-zorro.module';
import * as Lodash from 'lodash';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-search-group-setting',
  standalone: true,
  imports: [CommonModule, SharedZorroModule],
  templateUrl: './search-group-setting.component.html',
  styleUrl: './search-group-setting.component.less',
})
export class SearchGroupSettingComponent {
  @Input() data: any;
  searchParams = {
    name: '',
    predicates: {
      examinationStatuses: [] as string[],
      examinationTypes: [] as string[],
      sourceHospitalIdList: [] as string[],
      doctors: [] as string[],
      // deviceTypes: [] as string[],
    },
  };

  examinationStatuses = [
    { label: '已上传', value: 'UPLOADED', checked: false },
    { label: '已报告', value: 'REPORTED', checked: false },
    { label: '已诊断', value: 'AUDITED', checked: false },
  ];
  examinationTypes = [
    { label: '急诊', value: '急诊', checked: false },
    { label: '门诊', value: '门诊', checked: false },
  ];
  sourceHospitalIdList = [
    { label: '北京协和医院', value: '1' },
    { label: '北京同仁医院', value: '2' },
  ];
  doctors = [
    { label: '张三', value: '1' },
    { label: '李四', value: '2' },
  ];
  deviceTypes = [
    {
      label: 'CT',
      value: 'CT',
    },
    {
      label: 'DR',
      value: 'DR',
    },
    {
      label: 'CR',
      value: 'CR',
    },
    {
      label: 'RF',
      value: 'RF',
    },
    {
      label: 'MR',
      value: 'MR',
    },
    {
      label: 'US',
      value: 'US',
    },
    {
      label: 'NM',
      value: 'NM',
    },
    {
      label: 'XA',
      value: 'XA',
    },
    {
      label: 'OT',
      value: 'OT',
    },
  ];

  constructor(private message: NzMessageService) {}

  ngOnInit() {
    if (this.data.name) {
      this.searchParams.name = this.data.name;
      this.searchParams.predicates = this.data.predicates;
      this.updateExaminationStatuses();
      this.updateExaminationTypes();
    }
  }

  updateExaminationStatuses() {
    this.examinationStatuses.forEach((item) => {
      item.checked = Lodash.includes(this.searchParams.predicates.examinationStatuses, item.value);
    });
  }

  updateExaminationTypes() {
    this.examinationTypes.forEach((item) => {
      item.checked = Lodash.includes(this.searchParams.predicates.examinationTypes, item.value);
    });
  }

  onCheckboxChange(event: any, option: any, type: string) {
    if (type === 'examinationStatuses') {
      if (event) {
        setTimeout(() => {
          let _arr: any[] = [];
          this.examinationStatuses.forEach((item) => {
            if (item.checked) {
              _arr.push(item.value);
            }
          });
          this.searchParams.predicates.examinationStatuses = _arr;
        }, 1);
      }
    } else if (type === 'examinationTypes') {
      if (event) {
        let _arr: any[] = [];
        this.examinationTypes.forEach((item) => {
          if (item.checked) {
            _arr.push(item.value);
          }
        });
        this.searchParams.predicates.examinationTypes = _arr;
      }
    }
  }

  getValues() {
    // 校验数据
    if (!this.searchParams.name) {
      this.message.error('请输入名称');
      return;
    }
    return this.searchParams;
  }
}
